import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import React, { useMemo } from 'react';
import { Card } from '@totalsoft/rocket-ui';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { leasingServiceTypesStore } from '../store';
import { LEASING_SERVICE_CATEGORIES, LEASING_SERVICE_TYPES } from '../../queries';
import { CollectionType } from '@ts-private/list-browser';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import ItemComponent from './ItemComponent';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';

const BrowserComponent = () => {
  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: LEASING_SERVICE_TYPES,
        name: 'leasingServiceTypes'
      },
      collectionsOptions: [
        {
          queryOptions: { query: LEASING_SERVICE_CATEGORIES },
          name: 'leasingServiceCategories',
          identifier: 'categoryId',
          collectionType: CollectionType.Filter,
          valueKey: 'id',
          labelKey: 'name'
        }
      ]
    }),
    []
  );

  const columns = useMemo(
    () => [
      { name: 'code', caption: 'LeasingServiceType.Code' },
      { name: 'name', caption: 'LeasingServiceType.Name' },
      { name: 'category', caption: 'LeasingServiceType.Category', width: '20%' },
      { name: 'actions', caption: 'Actions', width: '120px' }
    ],
    []
  );

  return (
    <Card icon={ListAltIcon}>
      <TableListBrowser store={leasingServiceTypesStore} ItemComponent={ItemComponent} columns={columns} />
      <ExportModalComponent store={leasingServiceTypesStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={leasingServiceTypesStore} options={fetchingOptions} />
    </Card>
  );
};

export default BrowserComponent;
